const PARENT_DOMAIN = '.entregadigital.app.br';
const SESSION_SUFFIX = '_session';

function deleteCookie(name: string, domain: string): void {
  document.cookie = `${name}=; Domain=${domain}; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

export function cleanupForeignSessionCookies(): void {
  const cookies = document.cookie ? document.cookie.split(';') : [];
  const removed: string[] = [];

  for (const cookie of cookies) {
    const name = cookie.trim().split('=')[0];
    if (name.endsWith(SESSION_SUFFIX)) {
      deleteCookie(name, PARENT_DOMAIN);
      removed.push(name);
    }
  }

  if (removed.length > 0) {
    console.info(`[cookie-cleanup] removidos ${removed.length} session cookie(s):`, removed);
  }
}

export function warnIfCookieHeaderTooLarge(thresholdBytes = 4000): void {
  const size = document.cookie.length;
  if (size > thresholdBytes) {
    console.warn(`[cookie-bloat] header de cookies com ${size} bytes (limite nginx ~8192)`);
  }
}
